module.exports = "<ngx-loading [show]=\"loading\" [config]=\"{fullScreenBackdrop: false, backdropBackgroundColour: 'rgba(186, 186, 186, 0.4)'}\"></ngx-loading>\n\n<div class=\"card\">\n    <div class=\"card-content\">\n        <h6 class=\"big-title\">Sucursales importantes</h6>\n        <canvas id=\"cvsSucursalesImportantes\" height=\"200\"></canvas>\n    </div>\n</div>"


//////////////////
// WEBPACK FOOTER
// /var/www/nodejs/nextstore/src/app/components/charts/sucursal-mas-ventas/sucursal-mas-ventas.component.html
// module id = ../../../../../src/app/components/charts/sucursal-mas-ventas/sucursal-mas-ventas.component.html
// module chunks = main